<template>
  <div>
      {{ label ? $t(label).concat(': ') : ''}}
    <v-btn
      :color="this.height !== '36px' ? '#FFFFFF' : selectedColor"
      :style="{ 'width': width, 
        'height': height, 
        'min-width': this.height !== '36px' ? '50px' : '64px',
        'border' : this.height !== '36px' ? '1px solid rgba(0, 0, 0, 0.12)' : ''
      }"
      @click="overlay = !overlay"
      :elevation="this.height !== '36px' ? 0 : 1"
    >
      <v-icon 
        v-if="icon"
        :style="{ 'color': this.height !== '36px' ? selectedColor : enterpriseColor,'font-size': this.height !== '36px' ? '26px' : '30px'}"
        style="margin-top:5px;opacity:0.5"
      >
        {{icon}}
      </v-icon>
    </v-btn>
    <v-dialog v-model="overlay" persistent max-width="330px" >
      <v-card style="padding: 10px;">
    <!-- <v-overlay
      :value="overlay"
      style="position:absolute"
    > -->
      <v-color-picker
        v-model="selectedColor"
        class="ma-2"
        :swatches="swatches"
        show-swatches
        mode="hexa"
        @input="handleChangeColor"
      />
      <center>
      <v-btn
        @click="overlay = false"
        style="margin-bottom:10px;"
      >
        <v-icon>mdi-close</v-icon> {{$t('common.close')}}
      </v-btn>
    </center>
    <!-- </v-overlay> -->
    </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'CustomColorPicker',
    props: {
      label: {
        type: String,
        required: false,
        default: null
      },
      icon: {
        type: String,
        required: false,
        default: null
      },
      width: {
        type: String,
        required: false,
        default: null
      },
      height: {
        type: String,
        required: false,
        default: '36px'
      },
      color: {
        type: String,
        required: true
      },
      onChangeColor: {
        type: Function,
        required: true
      }
    },
    data: () => ({
      overlay: false,
      swatches: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#FFFFFF', '#0000AA', '#000055'],
      ],
      selectedColor: '#fff'
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
    watch: {
      color (v) {
        if (v) this.selectedColor = v
      }
    },
    mounted () {
      this.selectedColor = this.color ? this.color : '#fff'
    },
    methods: {
      handleChangeColor () {
        this.overlay = false
        this.onChangeColor(this.selectedColor)
      }
    }
  }
</script>